const INIT_FROM_VALUES = {
  name: "",
  email: "",
  theme: "",
  message: "",
};

export default INIT_FROM_VALUES;
